import ProviderComparisonWidget from './ProviderComparisonWidget';
import withProviderComparisonResources from './components/withProviderComparisonResources';

const ProviderComparison = withProviderComparisonResources(ProviderComparisonWidget);

export { ProviderComparisonWidget, ProviderComparison };
